import _ from 'lodash'
import _inflection from 'lodash-inflection';
_.mixin(_inflection)

export const camelizeKeys = (obj) => {
  return _.mapKeys(obj, (v, k) => _.camelCase(k))
}

export const underscoreKeys = (obj) => {
  return _.mapKeys(obj, (v, k) => _.snakeCase(k))
}

export const deepCamelizeKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((v) => deepCamelizeKeys(v))
  } else if (obj !== null && typeof obj === 'object') {
    return _.mapValues(_.mapKeys(obj, (v, k) => _.camelCase(k)), (v) => deepCamelizeKeys(v))
  } else {
    return obj
  }
}

export const deepUnderscoreKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((v) => deepUnderscoreKeys(v))
  } else if (obj !== null && typeof obj === 'object') {
    return _.mapValues(_.mapKeys(obj, (v, k) => _.snakeCase(k)), (v) => deepUnderscoreKeys(v))
  } else {
    return obj
  }
}
